import { unwrapSearchFilters } from '@/shared/components/filters/searchFilters';

import type { AllSearchDomain } from '../../../../searchTabs';

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

export const hasSearchFilterValue = (value: unknown): boolean => {
    if (value === undefined || value === null || value === '') {
        return false;
    }
    if (Array.isArray(value)) {
        return value.some(hasSearchFilterValue);
    }
    if (isRecord(value)) {
        return Object.values(value).some(hasSearchFilterValue);
    }

    return true;
};

export const getActiveSearchFilterDomains = (
    filters: unknown,
    domains: readonly AllSearchDomain[],
): AllSearchDomain[] => {
    const filtersRecord = unwrapSearchFilters(filters);
    const searchDomains = isRecord(filtersRecord.searchDomains) ? filtersRecord.searchDomains : {};

    return domains.filter((domain) => hasSearchFilterValue(searchDomains[domain]));
};

export const hasActiveSearchDomainFilters = (filters: unknown, domains: readonly AllSearchDomain[]): boolean =>
    getActiveSearchFilterDomains(filters, domains).length > 0;
